<fin-cms-global-disruption-banner></fin-cms-global-disruption-banner>

@if ((viewIsNotCheckinInsideApp$ | async) === true) {
  @if ((isShowLoginHeader$ | async) === true) {
    <fin-header></fin-header>
  } @else {
    <fcom-booking-header
      [loggedIn]="(loginStatus$ | async) === LoginStatus.LOGGED_IN"
      [homeUrl]="homeUrl"
      [showLogin]="true"
      [showBack]="isReviewStage$ | async"
      [propagateBackClick]="isReviewStage$ | async"
      [userName]="profileName$ | async"
      [profileType]="profileType$ | async"
      [phasesAria]="{
        pastStep: 'phases.aria.previous' | finLocalization,
        currentStep: 'phases.aria.current' | finLocalization,
        futureStep: 'phases.aria.next' | finLocalization,
      }"
      (menuClick)="toggleMenu()"
      (loginClick)="loginDialog.toggleLogin($event)"
      (backClick)="navigateBackFromReview()"
      (homeClick)="onHomeClick($event)"
    >
    </fcom-booking-header>
  }
} @else {
  <!-- Needed for for SSR rehydration removal -->
}

<fin-login-dialog
  *ngIf="(isShowLoginHeader$ | async) === false"
  [context]="LoginWidgetContext.MMB"
  #loginDialog
></fin-login-dialog>

<ng-container *ngIf="stage$ | async as stage">
  <ng-container [ngSwitch]="stage">
    <ng-container *ngSwitchCase="MmbStage.CHECK_IN_FLOW">
      <div (finMutationObserver)="trackCTAButton()" (finObserverRemoved)="removeCTAButtonClass()">
        <router-outlet></router-outlet>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="MmbStage.LOGIN">
      <ng-container *ngTemplateOutlet="singleColumnLayout"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div
        (finMutationObserver)="trackCTAButton()"
        (finObserverRemoved)="removeCTAButtonClass()"
        class="grey-25-bg"
        *ngIf="booking$ | async as booking"
        [class.is-hidden]="(isNavigationMenuOpen$ | async) ? true : null"
      >
        <fin-sub-header
          [showInfoIcon]="false"
          [hasBasket]="hasBasket$ | async"
          [isBasketDisabled]="false"
          [hasActiveBasketState]="hasUnpaidServices$ | async"
          [hasBasketActionInMobileOnly]="false"
          [backgroundColorClass]="'nordic-blue-900-bg'"
          (openBasket)="openBasket()"
        >
          <fin-booking-header-summary
            *ngIf="bookingSummary$ | async as bookingSummary"
            [bookingSummary]="bookingSummary"
          ></fin-booking-header-summary>
        </fin-sub-header>

        <main>
          <div class="grid-max-width center grid-col-12 no-row-gap">
            <ng-container *ngIf="hasTwoColumnLayout$ | async; else singleColumnLayout">
              <h1 class="col-1-12 nordic-blue-900-text font-heading-1 mr-medium-b mr-large-t" [ngSwitch]="stage">
                <ng-container *ngSwitchCase="MmbStage.VIEW">
                  {{ 'MMB.labels.manageBooking' | finLocalization }}
                </ng-container>
                <ng-container *ngSwitchCase="MmbStage.PASSENGERS">
                  {{ 'MMB.labels.passengerDetails' | finLocalization }}
                </ng-container>
                <ng-container *ngSwitchCase="MmbStage.TRAVEL_PREPARATION">
                  {{ 'MMB.labels.travelPreparations' | finLocalization }}
                </ng-container>
                <ng-container *ngSwitchCase="MmbStage.CAR_RENTAL">
                  {{
                    (enableExpediaWidget ? 'MMB.labels.hotelsAndCarRental' : 'MMB.labels.carRental') | finLocalization
                  }}
                </ng-container>
              </h1>

              <aside class="col-1-12 md-col-1-4">
                <fin-mmb-side-navigation></fin-mmb-side-navigation>
              </aside>

              <div class="col-1-12 md-col-5-12">
                <router-outlet></router-outlet>
              </div>

              <fin-cms-json-content
                *ngIf="
                  (template$ | async) &&
                  stage !== MmbStage.TRAVEL_PREPARATION &&
                  (bookingIsDisrupted$ | async) === false
                "
                class="grid-max-width center grid-col-12 col-1-12"
                [template$]="template$"
                [class.cta-button-bottom-padding]="(hasUnpaidServices$ | async) && stage === MmbStage.VIEW"
              >
              </fin-cms-json-content>
            </ng-container>
          </div>
        </main>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #singleColumnLayout>
    <router-outlet></router-outlet>
  </ng-template>

  <div aria-live="assertive" class="page-announcer" tabindex="-1">
    <span class="is-vishidden" *ngIf="title$ | async as title">{{
      'navigation.pageChangedTo' | finLocalization: { pageTitle: title }
    }}</span>
  </div>
</ng-container>
